import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import { Button, DatePicker, Form, Input, Radio, Row } from "antd";
import AWS from "aws-sdk";
import moment from "moment";

import Swal from "sweetalert2";

import channelUserApi from "../../apis/ChannelUser.api";
import commentApi from "../../apis/Comment.api";
import { toastAlert } from "../../components/AlertComponent";
import { setChannelUser, setUser } from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const MyPage = () => {
	const cUser = useSelector((state) => state.auth.channelUser);
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [isSendSms, setIsSendSms] = useState(false);
	const [smsValid, setSmsValid] = useState(false);

	const provider =
		cUser?.provider === "kakao"
			? "카카오톡 로그인"
			: cUser?.provider === "naver"
			? "네이버 로그인"
			: "일반 로그인";

	const [userInfo, setUserInfo] = useState({
		nickname: "",
		phone: "",
		phone_valid: null,
	});

	const [gender, setGender] = useState(1);
	const [genderAge, setGenderAge] = useState({
		gender: 1,
		age: moment(),
	});

	const inputRef = useRef(null);
	// const [photo, setPhoto] = useState({});
	const [imgSrc, setImgSrc] = useState("/assets/images/channel/basic.png");

	useEffect(async () => {
		const param = {
			userId: cUser?.id,
		};
		const res = await commentApi.getCUserByUserId(param);
		if (res.code === 200) {
			dispatch(setChannelUser(res.result));
		}
		window.scrollTo({
			top: 0,
		});
	}, []);

	useEffect(() => {
		if (cUser?.id) {
			setUserInfo({
				nickname: cUser?.nickname,
				phone: cUser?.phone,
				phone_valid: null,
			});
			if (cUser?.is_influencer) {
				setImgSrc(
					`${process.env.REACT_APP_S3_HOST}/image/together/profile_${cUser.id}.${cUser.profile_img_type}`
				);
			} else {
				if (cUser?.profile_img_type) {
					setImgSrc(
						`${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${cUser.id}.${cUser.profile_img_type}`
					);
				} else {
					setImgSrc(`/assets/images/channel/basic.png`);
				}
			}
			if (cUser.gender) {
				setGenderAge({
					...genderAge,
					gender: cUser.gender,
				});
				setGender(cUser.gender);
			} else {
				setGenderAge({
					...genderAge,
					gender: null,
				});
			}
			if (cUser?.birthday) {
				setGenderAge({
					...genderAge,
					age: moment(cUser.birthday),
				});
			} else {
				setGenderAge({
					...genderAge,
					age: moment(),
				});
			}
		} else {
			history.replace(`/together/channel?id=${reduxChannel?.influencer_id}`);
		}
	}, [cUser]);

	useEffect(() => {
		setGenderAge({
			...genderAge,
			gender: gender,
		});
	}, [gender]);

	/**
	 * 폼 입력 받기
	 * 닉네임 : 언제든지 수정가능
	 * 휴대폰 : 일반 로그인시에만 수정 가능
	 * @param e
	 */
	const handleForm = (e) => {
		let { name, value } = e.target;
		let phone = value?.replaceAll(/[^0-9]/g, "");
		if (name === "phone") {
			if (phone?.length <= 11) {
				setUserInfo({
					...userInfo,
					phone: phone,
				});
			}
		} else if (name === "phone_valid") {
			if (phone?.length <= 6) {
				setUserInfo({
					...userInfo,
					[name]: phone,
				});
			}
		} else {
			setUserInfo({
				...userInfo,
				[name]: value,
			});
		}
	};

	const onChangeGender = (e) => {
		setGenderAge({
			...genderAge,
			gender: e.target.value,
		});
	};

	const onChangeDate = (date, dateString) => {
		setGenderAge({
			...genderAge,
			age: date,
		});
	};

	/**
	 * step 2-1: 휴대폰 인증번호 확인
	 * @returns {Promise<void>}
	 */
	const sendPhoneValid = async () => {
		let regPhone = /010-?([0-9]{4})-?([0-9]{4})$/;
		if (regPhone.test(userInfo.phone) && reduxChannel?.nickname !== null) {
			setIsLoading(true);
			let param = {
				is_user_valid: true,
				phone: userInfo.phone,
				influencer_id: reduxChannel?.user_id,
				influencer_channel_name: reduxChannel?.nickname,
			};
			let res = await channelUserApi.sendSms(param);
			if (res.code === 200) {
				if (res.result.id_check) {
					const loginMethod =
						res.result.user?.provider === "kakao"
							? "카카오"
							: res.result.user?.provider === "naver"
							? "네이버"
							: "해당 번호";

					Swal.fire({
						customClass: "alert-custom",
						text: `${loginMethod}로 가입된 유저가 있습니다.\n로그인 하시겠습니까?`,
						showCancelButton: true,
						confirmButtonText: "확인",
						cancelButtonText: "취소",
					}).then(async (result) => {
						if (result.isConfirmed) {
							history.push(
								`/together/channel/login?id=${reduxChannel?.influencer_id}`
							);
						}
					});
				} else {
					setIsSendSms(true);
				}
				setIsLoading(false);
			} else {
				toastAlert("휴대폰 번호를 정확하게 입력해주세요.");
				setIsLoading(false);
			}
		} else {
			toastAlert("휴대폰 번호를 정확하게 입력해주세요.");
		}
	};

	/**
	 * step 2-2: 휴대폰 인증번호 일치 확인
	 */
	const checkPhoneValid = async () => {
		const regPhone = /([0-9]{6})$/;
		if (regPhone.test(userInfo.phone_valid)) {
			setIsLoading(true);

			let param = {
				phone: userInfo.phone,
				sms_verify_code: userInfo.phone_valid,
			};
			let res = await channelUserApi.sendSmsValid(param);

			if (res.code === 200) {
				toastAlert("인증번호가 일치합니다.");
				setSmsValid(true);
				setIsLoading(false);
			} else {
				toastAlert("인증번호가 일치하지 않습니다.");
				setIsLoading(false);
			}
		} else {
			toastAlert("휴대폰 번호를 정확하게 입력해주세요.");
		}
	};

	/**
	 * 수정하기 버튼 클릭
	 * @returns {Promise<void>}
	 */
	const editUser = async () => {
		if (!!userInfo?.phone?.length && !!userInfo?.nickname?.length) {
			const param = {
				...cUser,
				id: cUser?.id,
				phone: userInfo?.phone,
				nickname: userInfo?.nickname,
				gender: genderAge?.gender,
				birthday: genderAge?.age,
			};
			setIsLoading(true);
			const res = await channelUserApi.editChannelUser(param);
			if (res.code === 200) {
				dispatch(
					setChannelUser({
						...cUser,
						nickname: userInfo?.nickname,
						phone: userInfo?.phone,
						gender: genderAge?.gender,
						birthday: genderAge?.age,
					})
				);
				toastAlert("성공적으로 적용되었습니다!");
				setIsSendSms(false);
				setSmsValid(false);
				setIsLoading(false);
			} else if (res.code === 999) {
				toastAlert("해당 닉네임이 존재합니다. 다시 입력해 주세요.");
				setIsLoading(false);
			} else {
				toastAlert("오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
				setIsLoading(false);
			}
		} else {
			toastAlert("정확하게 입력해주세요.");
			setIsLoading(false);
		}
	};

	/**
	 * 회원 탈퇴
	 * @returns {Promise<void>}
	 */
	const withdrawUser = async () => {
		if (cUser?.is_influencer) {
			toastAlert("관리자는 탈퇴하실 수 없습니다.");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "정말 탈퇴하시겠습니까?",
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setIsLoading(true);
					const param = {
						userId: cUser?.id,
						influencer_id: reduxChannel?.user_id,
					};
					const res = await channelUserApi.leave(param);
					if (res.code === 200) {
						Swal.fire({
							customClass: "alert-custom",
							text: "탈퇴가 정상적으로 완료되었습니다.",
							confirmButtonText: "확인",
						}).then(() => {
							dispatch(setChannelUser(null));
							setIsLoading(false);
						});
					} else {
						Swal.fire({
							customClass: "alert-custom",
							text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
							confirmButtonText: "확인",
						}).then(() => {
							setIsLoading(false);
						});
					}
				}
			});
		}
	};

	/**
	 * 유저 로그아웃
	 * @param e
	 * @returns {Promise<void>}
	 */
	const userLogout = async (e) => {
		e.preventDefault();

		Swal.fire({
			customClass: "alert-custom",
			text: "정말 로그아웃 하시겠습니까?",
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				const param = {
					id: cUser?.id,
					influencer_id: reduxChannel?.user_id,
				};
				const res = await channelUserApi.logout(param);
				if (res.code === 200) {
					localStorage.removeItem("accessToken");
					localStorage.removeItem("refreshToken");
					localStorage.removeItem("admin:accessToken");
					localStorage.removeItem("admin:refreshToken");
					Swal.fire({
						customClass: "alert-custom",
						text: "로그아웃이 되었습니다.",
						confirmButtonText: "확인",
					}).then((res) => {
						const queryJson = queryString.parse(
							window.location.search?.replace("?", "")
						);
						const userId = queryJson?.userId;
						if (userId) {
							const { pathname, search } = history?.location ?? {};
							const newSearch = search?.split("&userId")[0];
							history.replace(`${pathname + newSearch}`);
						} else {
							window.scrollTo({
								top: 0,
								// behavior: 'smooth'
							});
						}

						dispatch(setChannelUser(null));
						dispatch(setUser(null));
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					});
				}
			}
		});
	};

	/**
	 * 프론트 내 업로드 버튼 클릭
	 */
	const onUploadImageClick = () => {
		if (!inputRef.current) {
			return;
		}
		inputRef.current.click();
	};

	/**
	 * 프론트 내 업로드 진행
	 * @param e
	 */
	const onUploadImage = (e) => {
		if (!e.target.files) {
			return;
		}
		const fileList = e.target.files[0];
		const url = URL?.createObjectURL(fileList);
		let photoInfo = {
			file: fileList,
			source: url,
			type: fileList.type,
		};
		setImgSrc(photoInfo.source);
		// setPhoto(photoInfo);
		if (photoInfo.source) {
			uploadToS3(photoInfo);
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param photo
	 */
	const uploadToS3 = async (photo) => {
		let fileType = photo?.type.split("/")[1];
		let s3Path = `image/together/channel_user/profile/${cUser.id}.${fileType}`;
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			const param = {
				...cUser,
				profile_img_type: fileType,
			};
			const rsp = await channelUserApi.editChannelUser(param);
			if (rsp.code === 200) {
				console.log("정상적으로 저장되었습니다.");
				// Swal.fire({
				//     customClass: "alert-custom",
				//     text: '정상적으로 저장되었습니다.',
				//     confirmButtonText: "확인",
				// }).then(() => {
				// })
			} else {
				Swal.fire({
					customClass: "alert-custom",
					text: "이미지 업로드 오류",
					confirmButtonText: "확인",
				}).then(() => {});
			}
			// getInfo();
		} else {
			// alert("이미지 업로드 오류");
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {});
		}
		// getProductList(selectKey);
		// setModalShow(false);
	};

	return (
		<div className="channel-wrap channel-home">
			<div className={`channel-wrap channel-home channel-delay`}>
				<div className={`home-each`}>
					<div className={`max-width-apply home-group-buying`}>
						<div className={`home-recommend-horizontal channel-mypage`}>
							<div className={`recommend-title`}>
								<p className={`title`}>내 프로필</p>
							</div>
							<Form layout={`vertical`} className={`channel-mypage-form`}>
								<Form.Item
									label=""
									colon={false}
									className={`channel-mypage-input-item`}
								>
									<Button
										className={`edit-profile`}
										onClick={onUploadImageClick}
										disabled={isLoading || !!cUser?.is_influencer}
										style={{
											width: "fit-content",
											height: "fit-content",
											margin: "auto",
											border: "none",
											background: "none",
											padding: 0,
										}}
									>
										<input
											type="file"
											accept="image/*"
											style={{
												display: "none",
											}}
											ref={inputRef}
											onChange={onUploadImage}
										/>
										<img
											src={`${imgSrc}`}
											onError={({ currentTarget }) => {
												currentTarget.onerror = null; // prevents looping
												// currentTarget.style.display = "none";
												currentTarget.src = `/assets/images/channel/basic.png`;
											}}
											alt={`채널 이미지`}
											className={`basic-img`}
											style={{
												width: "7em",
												height: "7em",
											}}
										/>
										<img
											src={`/assets/images/channel/photo.png`}
											alt={`사진 수정`}
											className={`photo-img`}
										/>
									</Button>
								</Form.Item>

								{/* 연동계정 - 일반/카카오/네이버 */}
								<Form.Item
									label="연동계정"
									labelAlign="left"
									colon={false}
									className={`channel-mypage-input-item`}
								>
									<div className={`channel-mypage-input ant-input-disabled`}>
										<img
											src={`/assets/images/login/${
												cUser?.provider ? cUser?.provider : "signup-check"
											}.png`}
											alt={`user-icon`}
										/>
										{provider}
									</div>
								</Form.Item>

								{/* 닉네임 */}
								<Form.Item
									label="닉네임"
									labelAlign="left"
									colon={false}
									className={`channel-mypage-input-item`}
								>
									<Input
										type={`text`}
										name={`nickname`}
										className={`channel-mypage-input`}
										value={userInfo.nickname}
										onChange={handleForm}
										placeholder={`닉네임을 입력해주세요`}
										disabled={!!cUser?.is_influencer}
									/>
								</Form.Item>

								{/* 성별 */}
								<Form.Item
									label="성별"
									labelAlign="left"
									colon={false}
									fieldKey={`gender`}
									key={`gender`}
									// className={`channel-mypage-input-item`}
								>
									<Radio.Group
										onChange={onChangeGender}
										value={genderAge.gender}
										defaultValue={genderAge.gender}
										disabled={!!cUser?.is_influencer}
										style={{
											fontSize: "0.9em",
										}}
									>
										<Radio value={1}>여성</Radio>
										<Radio value={2}>남성</Radio>
									</Radio.Group>
								</Form.Item>

								{/* 생년월일 */}
								<Form.Item
									label="생년월일"
									labelAlign="left"
									colon={false}
									className={`channel-mypage-input-item`}
								>
									<DatePicker
										format={"YYYY년 MM월 DD일"}
										value={genderAge.age}
										onChange={onChangeDate}
										allowClear={false}
										className={`edit-age-datepicker`}
										disabled={!!cUser?.is_influencer}
										// placement={"bottomRight"}
									/>
								</Form.Item>

								{/* 휴대폰 번호 */}
								<Form.Item
									label="휴대폰 번호"
									labelAlign="left"
									colon={false}
									className={`channel-mypage-input-item`}
								>
									<Input
										type={`text`}
										name={`phone`}
										className={`channel-mypage-input`}
										value={userInfo.phone}
										pattern="\d*"
										onChange={handleForm}
										onPressEnter={sendPhoneValid}
										placeholder={`휴대폰 번호를 입력해주세요`}
										disabled={
											cUser?.provider === "kakao" ||
											cUser?.provider === "naver" ||
											!!cUser?.is_influencer
										}
									/>
									{cUser?.provider !== "kakao" &&
										cUser?.provider !== "naver" &&
										!cUser?.is_influencer && (
											<>
												{smsValid ? (
													<Button
														id={"nickname"}
														disabled={!smsValid}
														loading={isLoading}
														onClick={editUser}
													>
														수정하기
													</Button>
												) : (
													<Button
														id={"phone"}
														onClick={sendPhoneValid}
														disabled={
															userInfo?.phone === cUser?.phone ||
															(userInfo?.phone !== cUser?.phone && isSendSms)
														}
														loading={isLoading}
													>
														인증 요청
													</Button>
												)}
											</>
										)}
								</Form.Item>
								{!!isSendSms && (
									<Form.Item
										label=""
										labelAlign="left"
										colon={false}
										className={`channel-mypage-input-item`}
										style={{
											marginTop: "-1em",
										}}
									>
										<Input
											type={`text`}
											name={`phone_valid`}
											className={`channel-mypage-input`}
											placeholder={`인증번호 6자리를 입력해주세요`}
											value={userInfo.phone_valid}
											pattern="\d*"
											onChange={handleForm}
											onPressEnter={checkPhoneValid}
											disabled={smsValid}
										/>
										{smsValid ? (
											<Button
												className={`button-width-full finish-gray`}
												disabled={true}
												onClick={editUser}
											>
												인증 완료
											</Button>
										) : (
											<Button
												className={`button-width-full`}
												onClick={checkPhoneValid}
												loading={isLoading}
												disabled={
													!userInfo.phone_valid ||
													userInfo.phone_valid?.length < 6
												}
											>
												인증번호 확인
											</Button>
										)}
									</Form.Item>
								)}
							</Form>
							{!cUser?.is_influencer && (
								<Button
									className={`edit-user-info-button`}
									id={"nickname"}
									disabled={
										userInfo?.nickname === cUser?.nickname &&
										genderAge.gender === cUser?.gender &&
										genderAge.age.format("YYYYMMDD") ===
											moment(cUser?.birthday).format("YYYYMMDD")
									}
									loading={isLoading}
									onClick={editUser}
								>
									수정하기
								</Button>
							)}
							<Row justify={"center"}>
								<button className={`channel-withdraw`} onClick={userLogout}>
									로그아웃
								</button>
								<button className={`channel-withdraw`} onClick={withdrawUser}>
									탈퇴하기
								</button>
							</Row>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default MyPage;
